import { combineReducers } from 'redux';

import { reducer as details } from './detailsModule';

export default combineReducers({
	details,
});
